var hiddenStore = require('./hidden-store.js');

module.exports = createStore;

function createStore() {
  var key = {};
  return function (obj) {
    if ((typeof obj !== 'object' || obj === null) && typeof obj !== 'function') {
      throw new Error('Weakmap-shim: Key must be object');
    }

    var store = obj.valueOf(key);
    return store && store.identity === key ? store : hiddenStore(obj, key);
  };
}